import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchStates } from '../api/geography.api';
import { GEOGRAPHY_KEYS } from './geography.keys';

/** Near-static (5,308 rows worldwide, ~637KB) - long staleTime, prefetched. */
const STALE_TIME_MS = 24 * 60 * 60 * 1000;

/**
 * Fetches every state/province worldwide once; `countryId` filters the
 * already-cached list client-side rather than round-tripping per country
 * selection (MYN-46 - the whole table is small enough for this).
 */
export function useStates(countryId: number | undefined) {
  const query = useQuery({
    queryKey: GEOGRAPHY_KEYS.states,
    queryFn: fetchStates,
    staleTime: STALE_TIME_MS,
  });

  const states = useMemo(
    () => (countryId ? (query.data ?? []).filter((state) => state.countryId === countryId) : []),
    [query.data, countryId],
  );

  return { ...query, states };
}
